export default "__VITE_ASSET__jAY7RxLL__"